/**
 * Notificações da construtora: ver e enviar são permissões independentes
 * (uma não inclui a outra). A API valida as duas; aqui só decide o que a
 * tela mostra e para onde mandar quem não pode.
 */
const lista = (user) => String(user?.permissoes || '').split(',');

export const podeVerAvisos = (user) => lista(user).includes('avisos-visualizar');

export const podeEnviarAvisos = (user) => lista(user).includes('avisos-enviar');
